exports.default = {
  'projects': 'Projects',
  'search_document': 'Search pages...',
  'create_project': 'Create Project',
  'new_project': 'New Project',
  'recently_visited': 'Recently Viewed',
  'no_recent_visits': 'No Recent Visits',
  'all_projects': 'All Projects',
  'no_projects_created': 'You haven\'t created any projects yet',
  'no_conversation_history': 'No chat history',
  'edit': 'Edit',
  'new_page': 'New Page',
  'project_name': 'Project Name',
  'project_name_placeholder': 'Enter project name',
  'project_description': 'Description',
  'project_description_placeholder': 'Enter project description',
  'project_cover': 'Cover Image',
  'project_name_max_length': 'Project name cannot exceed 50 characters',
  'cover_preview': 'Preview',
  'input_title': 'Enter title',
  'all': 'All',
  'color': 'Color',
  'document_belongs_to': 'Document belongs to',
  'work': 'Office',
  'technology': 'Tech',
  'no_access_content': 'Create your first page',
  'scenery': 'Landscape',
  'random_cover': 'Random Cover',
  'random_cover_success': 'Cover randomly selected',
  'project_name_error': 'Project name input incorrect, cannot delete',
  'upload_cover': 'Upload Cover',
  'dark': 'Dark',
  'light': 'Light',
  'no_conversation': 'You haven\'t had any conversation with any agents',
  'upload_success': 'Cover uploaded successfully',
  'delete_project': 'Delete Project',
  'development_tool': 'Development Tool Usage',
  'delete_warning': 'Warning: This will permanently delete the project and all its pages.',
  'confirm_by_name': 'Type project name to confirm deletion:',
  'delete_success': 'Deleted successfully',
  'name_incorrect': 'Project name input incorrect, cannot delete',
  'add_failed': 'Add failed',
  'edit_failed': 'Edit failed',
  'create_copy': 'Duplicate',
  'copy_name_placeholder': 'Please enter copy name',
  'add_doc_placeholder': 'Please enter document name',
  'search_project': 'Search Projects',
  'cancel': 'Cancel',
  'add_as_copy': 'Add as Copy',
  'unnamed_doc': 'Untitled',
  'add_success': 'Added successfully',
  'get_recent_list_failed': 'Failed to get recent access list',
  'search': 'Search',
  'catalog': 'Content',
  'new_document': 'New Document',
  'new_web_page': 'New Webpage',
  'add_doc_to': 'Add to',
  'mobile_choose_project': 'Choose Project',
  'mobile_choose_location': 'Choose Page Location',
  'mobile_next_step': 'Next',
  'mobile_load_more_projects': 'Load more projects',
  'document_actions': 'Page actions',
  'ai_assistant': 'AI assistant',
  'default_move_to': 'Move from current project to',
  'import_document': 'Import Document',
  'add_group': 'New Document',
  'recently_modified': 'Last modified',
  'download': 'Download',
  'copy_success': 'Copy successful',
  'copy_failed': 'Copy failed, please try again later!',
  'operation_failed': 'Operation failed, please try again later',
  'modify_failed': 'Modify failed',
  'untitled_document': 'Untitled Document',
  'untitled_webpage': 'Untitled Webpage',
  'delete_file_title': 'Delete: {filename}?',
  'delete_file_warning': 'This page cannot be recovered after deletion. Please proceed with caution!',
  'delete_document_confirmation': 'Delete current document, please be cautious.',
  'delete_document': 'Delete Document',
  'confirm': 'Confirm',
  'executing': 'Executing...',
  'close': 'Close',
  'cannot_move_tooltip': 'Not supported to move to original position or subitem',
  'group_name_placeholder': 'Please enter group name',
  'create_document': 'New Document',
  'rename': 'Rename',
  'move': 'Move',
  'delete': 'Delete',
  'sidebar_tooltip': 'Sidebar',
  'prev_page_tooltip': 'Previous Page',
  'next_page_tooltip': 'Next Page',
  'zoom_out_tooltip': 'Zoom Out',
  'zoom_in_tooltip': 'Zoom In',
  'download_tooltip': 'Download',
  'quote': 'Quote',
  'rewrite': 'Rewrite',
  'rewrite_beautify': 'Beautify',
  'rewrite_simple': 'Simplify Language',
  'rewrite_expand': 'Expand Rich',
  'rewrite_popular': 'Simplify',
  'explain': 'Explain',
  'summary': 'Summary',
  'translate': 'Translate',
  'translate_zh_cn': 'Chinese',
  'translate_en_us': 'English',
  'translate_ja': 'Japanese',
  'translate_ko': 'Korean',
  'translate_fr': 'French',
  'translate_de': 'German',
  'loading_image': 'Loading Image',
  'find': 'Find',
  'find_in_file_placeholder': 'Find in file',
  'analyze': 'Analyze',
  'add_to_chat': 'Add to chat box',
  'esc_to_exit_tooltip': 'Press ESC to exit',
  'rewrite_request_content': 'Please rewrite the content in a more beautiful language',
  'rewrite_simple_request_content': 'Please rewrite the content in a more concise language',
  'rewrite_expand_request_content': 'Please rewrite the content in a more rich language',
  'rewrite_popular_request_content': 'Please rewrite the content in a more popular language',
  'explain_request_content': 'Please explain the content',
  'summary_request_content': 'Please summarize the content',
  'translate_zh_request_content': 'Please translate the content into Chinese',
  'translate_en_request_content': 'Please translate the content into English',
  'translate_ja_request_content': 'Please translate the content into Japanese',
  'translate_ko_request_content': 'Please translate the content into Korean',
  'translate_fr_request_content': 'Please translate the content into French',
  'translate_de_request_content': 'Please translate the content into German',
  'sync_success': 'Offline data has been synchronized to server',
  'sync_failed': 'Data synchronization failed, saved to local cache',
  'network_disconnected': 'Network disconnected, document saved to local cache',
  'cache_restored': 'Cache data has been restored',
  'unsync_cache_detected': 'Unsynced local cache data detected. Do you want to restore it?',
  'abandon': 'Abandon',
  'restore': 'Restore',
  'doc_not_exist': 'Document does not exist',
  'no_permission': 'You don’t have permission to access this page',
  'page_width_setting': 'Page width setting',
  'select_width': 'Select appropriate page width for current window',
  'wide': 'Wide',
  'full_wide': 'Full Width',
  'default': 'Default',
  'find_and_replace': 'Find and replace',
  'move_to': 'Move to',
  'download_doc_as': 'Download as',
  'project_deleted': 'The project has been deleted',
  'document_deleted': 'The document has been deleted',
  'toc': 'Table of Contents',
  'no_toc_found': 'No table of contents found',
  'locating': 'Locating',
  'replace': 'Replace',
  'replace_with': 'Replace with',
  'search_in_doc': 'Search within document',
  'enter_text': 'Please enter the text',
  'replace_all': 'Replace all',
  'previous': 'Previous',
  'next': 'Next',
  'confirm_delete_scope': 'Confirm Deletion Scope',
  'delete_only_this_page': 'Delete only this page',
  'delete_page_with_children': 'Delete this page and all its subpages',
  'exporting_wait_finish': 'Please wait for the current document to finish exporting',
  'exporting_in_progress': 'Exporting...',
  'exporting_completed': 'Export completed!',
  'exporting_failed_colon': 'Export failed:',
  'exporting_error_occurred_colon': 'An error occurred during export:',
  'export_pdf_generating': 'Generating PDF, this may take up to 2 minutes...',
  'export_pdf_failed': 'PDF export failed',
  'export_pdf_no_permission': 'No permission to export this document',
  'export_pdf_empty_doc': 'Document is empty, nothing to export',
  'export_pdf_busy': 'Export service is busy, please try again later',
  'export_pdf_fallback_confirm': 'Server-side export failed. Use browser print instead?',
  'export_pdf_use_browser_print': 'Use browser print',
  'access_scope': 'Project access',
  'access_private': 'Private',
  'access_team_read': 'Team read-only',
  'access_team_edit': 'Team editable'
}
